import { ClienteXCiudad } from "../../login/cliente_login";

export class AplicacionesTransporteResumen {
    constructor(
        public cliente?: string,
        public poliza?: string,
        public ict?: string,
        public mercaderia?: string,
        public aplicacion?: number,
        public FechaElaborado?: string,
        public estado?: string,
        public valorAsegurado?: number,
        public valorSobreSeguro?: number,
        public tasa?: number,
        public primaNeta?: number,
        public SuperBancos?: number,
        public DerechosEmision?: number,
        public IVA?: number,
        public PrimaTotal?: number,
        public SeguroCampesino?: number,
        public FechaDespacho?: string,
        public NumeroPedido?: string,
        public gastosAdicionales?: number
    ) { }
}

export class AplicacionesConsulta {
    constructor(
        public cliente?: ClienteXCiudad,
        public segmento?: number) { }
}

export class AplicacionEntityConsulta {
    constructor(
        public CiudadCodigo?: number,
        public ClienteCodigo?: number,
        public FechaDesde?: string,
        public FechaHasta?: string
    ) { }
}

export class AplicacionesMovimientos {
    constructor(
        public AlcanceMovimiento?: number,
        public Ciudad?: number,
        public Cliente?: number,
        public DetalleMovimiento?: number,
        public Fecha?: string,
        public NumeroAplicacion?: number,
        public NumeroMovimiento?: number,
        public Poliza?: string,
        public PrimaTotal?: number,
        public Unicod?: number,
        public Accion?: number
    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/aplicaciones_transporte_entity.ts